export default __webpack_public_path__ + "static/media/close_svg.72839070.svg";